import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { memo } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { toggleBackMusic } from "../../../modules/user";

import './index.less';


const ToggleBackMusic = ({ back_music, toggleBackMusic }) => {

    // console.log('ToggleBackMusic back_music:', back_music);

    return (<div className="back-music" onClick={toggleBackMusic}>
        <img alt="music" src={`./static/backmusic/music_${back_music?'off':'on'}.svg`} />
    </div>);

}

const mapStateToProps = ({ user }) => ({
    back_music: user.back_music,
});

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        toggleBackMusic
    },
    dispatch
);

export default memo(connect(mapStateToProps, mapDispatchToProps)(ToggleBackMusic));